import Head from 'next/head';
import SiteLayout from '@/components/layout/SiteLayout';
import { KontaktSection } from '@/components/sections/KontaktSection';
import { kontaktdaten } from '@/lib/content/einstellungen';

const seo = {
  title: 'Marlene Gujan Architektur AG | Kontakt',
  description: 'Kontaktieren Sie Marlene Gujan Architektur AG in Igis für Ihre Anfragen und Beratungen zu innovativen und maßgeschneiderten Architekturprojekten.',
  keywords: 'Kontakt, Architektur, Igis, Marlene Gujan, Anfragen, Beratung',
  canonicalUrl: 'https://www.gujan-architektur.ch/kontakt',
};

export default function Kontakt({ data }) {
  return (
    <SiteLayout>
      <Head>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <link rel="canonical" href={seo.canonicalUrl} />
      </Head>
      <KontaktSection data={data} />
    </SiteLayout>
  );
}

export async function getStaticProps() {
  return { props: { data: await kontaktdaten() }, revalidate: 300 };
}
